

<div class="mat-typography">
<img *ngIf="!!src && src.length > 0" [src]="src" alt="">
    <!-- <h3 *ngIf="!!title && title.length > 0">{{ title }}</h3> -->
  </div>
  
